<template>
  <!-- 异常原因 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          :data="menuTableData"
          style="width: 100%"
          row-key="typeId"
          border
          :height="leftHeight"
          default-expand-all
          @row-click="rowClickLeft"
          :tree-props="{
            children: 'childTypeList',
            hasChildren: 'hasChildren',
          }"
        >
          <el-table-column prop="typeName" label="异常类型" sortable width="180"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <span v-if="hasPermiss('aaaaa')" class="tablebut" @click.stop="menuadd(scope.row)">添加</span>

                <span v-if="hasPermiss('aaaaa')" class="tablebut" @click.stop="menumodify(scope.row)">修改</span>
                <span v-if="hasPermiss('aaaaa')" class="tablebut" @click.stop="delBtns(scope.row.typeId)">删除</span>
                <span v-if="scope.row.isShow == 0" class="tablebut" @click.stop="qiYong(scope.row.typeId)">启用</span>
                <span v-if="scope.row.isShow == 1" class="tablebut" @click.stop="jinYong(scope.row.typeId)">禁用</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button v-if="hasPermiss('aaaaa')" class="glo_btnItems glo_bgcMainColor" @click="menuadd()">新增类型</el-button>
            <el-button v-if="hasPermiss('aaaaa')" class="glo_btnItems glo_bgcMainColor" @click="addServe()">新增原因</el-button>
            <el-button @click="qiYong_R()" class="glo_btnItems">批量启用</el-button>
            <el-button @click="jinYong_R()" class="glo_btnItems">批量禁用</el-button>
            <el-button @click="DelServe_R()" class="glo_btnItems">批量删除</el-button>
          </div>
          <queryBtns :MoreConditions="MoreConditions" :showMoreBtns="false" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
        </div>
        <queryCondition ref="queryForm" :More="isHaseMore" :formConfig="queryCondditionDatas"></queryCondition>
        <div class="glo_Table">
          <el-table
            :height="tableHeigth"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            :highlight-current-row="true"
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
          >
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="220px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" @click.stop="editorServe(scope.row)">修改</el-button>
                  <el-button class="rbtns" @click.stop="qiYong_R(scope.row.reasonId)">启用</el-button>
                  <el-button class="rbtns" @click.stop="jinYong_R(scope.row.reasonId)">禁用</el-button>
                  <el-button class="rbtns" @click.stop="DelServe_R(scope.row.reasonId)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
      </div>
    </div>

    <!-- 弹窗类型 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormDataRef')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="menushowBOX" ref="dialogFormDataRef" :model="dialogFormData" label-width="100px" :rules="rules">
          <el-form-item class="dialogFormItems" prop="typeName" label="类型名称:">
            <el-input placeholder="请输入" clearable v-model="dialogFormData.typeName"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="parentId" label="上级类型名称:">
            <el-select v-model="dialogFormData.parentId" clearable placeholder="请输入关键词" filterable remote :loading="false" :remote-method="remoteMethod2">
              <el-option v-for="item in parentList" :key="item.exceptionTypeId" :label="item.typeName" :value="String(item.exceptionTypeId)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input placeholder="请输入" v-model="dialogFormData.sort"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isShow" label="启用状态:">
            <el-select clearable filterable v-model="dialogFormData.isShow" placeholder="请选择">
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="remark" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogFormData.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹框 原因-->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDiaR"
      @diaCancelBtn="handleCloseDiaR"
      @diaConfirmBtn="diaConfirmBtnR('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog" ref="dialogFormRef" :model="dialogForm" label-width="110px" :rules="rulesForm">
          <el-form-item class="dialogFormItems" label="原因编号:">
            <el-input v-model="dialogForm.number" placeholder="不填则自动生成"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="typeName" label="异常原因:">
            <el-input v-model="dialogForm.typeName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="parentId" label="归属异常类型:">
            <el-select v-model="dialogForm.parentId" clearable placeholder="请输入关键词" filterable remote :loading="false" :remote-method="remoteMethod2" @change="changeTypeName">
              <el-option v-for="(item, index) in parentList" :key="index" :label="item.typeName" :value="String(item.exceptionTypeId)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="排序:">
            <el-input v-model="dialogForm.sort" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" label="启用状态:">
            <el-select filterable clearable v-model="dialogForm.isShow" placeholder="请选择">
              <el-option v-for="(item, index) in isShowList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>


<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  mixins: [tableList],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      bumenTypeList: [], //部门类型
      dialogFormData: {
        isShow: "1",
        parentId: "",
        remark: "",
        sort: "1",
        typeName: "",
      },
      rules: {
        typeName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        isShow: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      menuTableData: [],
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        // parentName: "",
        // typeName: "",
        categoryName: "",
        typeName: "",
      },
      leftHeight: "75vh",
      head: [], //下载表头字段
      fileList: [],
      sortName: "货物品类类型模板", //排序名
      pageGroupName: "SystemSetting_AbnormalCause", //页面标识
      reportFiledsNumber: "admin_exception_reason_list", // 动态 条件、表头
      // selectTableData: [], //选中的数据

      deperIds: [],
      dialogType: "add", //add==新建   edit==修改

      parentList: [], //上级
      conflictTypeIds: [], //原来的冲突品类类型

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        number: "",
        isShow: "1",
        parentId: "",
        remark: "",
        sort: "1",
        typeName: "",
      },
      rulesForm: {
        typeName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        parentId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowList: [
        {
          name: "启用",
          val: "1",
        },
        {
          name: "禁用",
          val: "0",
        },
      ],
      dialogTypeR: "add",
    };
  },
  created() {},
  mounted() {},
  activated() {
    // 左边列表
    this.departmentHierarchy();
    this.remoteMethod2();
  },
  methods: {
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDiaR() {
      this.isShowDialog = false;
      this.dialogForm = {
        number: "",
        isShow: "1",
        parentId: "-1",
        remark: "",
        sort: "1",
        typeName: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnR(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTypeR == "add") {
            // 新建
            this.$API.addExceptionReason({ ...this.dialogForm }).then((res) => {
              this.isShowDialog = false;
              this.$message.success(res.data.message || "新建成功");
              this.getData();
            });
          } else {
            // 编辑
            this.$API
              .udpateExceptionReason({ ...this.dialogForm })
              .then((res) => {
                this.isShowDialog = false;
                this.$message.success(res.data.message || "修改成功");
                this.getData();
              });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    // 新建
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "新增异常原因";
      this.dialogTypeR = "add";
      this.remoteMethod2();
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    // 编辑
    async editorServe(row) {
      await this.remoteMethod2();
      this.dialogForm = row;
      this.isShowDialog = true;
      this.dialogTitle = "修改异常原因";
      this.dialogTypeR = "edit";
    },
    // 删除
    DelServe_R(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.reasonId);
        });
      }
      this.$confirm("是否删除所选数据?", "提示:")
        .then((respon) => {
          this.$API.delExceptionReason({ reasonIds: ids }).then((res) => {
            this.$message.success(res.data.message || "删除成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 启用
    qiYong_R(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.reasonId);
        });
      }
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          this.$API.startExceptionReason({ reasonIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 禁用
    jinYong_R(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.reasonId);
        });
      }
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          this.$API.stopExceptionReason({ reasonIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.getData();
          });
        })
        .catch((error) => {});
    },

    // =======================================

    // 查询条件
    changeTypeName1(e) {
      if (!e) {
        this.remoteMethod2();
      }
      this.queryBtn_ok();
    },

    changeTypeName(e) {
      if (!e) {
        this.remoteMethod2();
      }
    },

    // 批量启用
    qiYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.typeId);
          });
          this.$API.wtl_startCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 批量禁用
    jinYongMore() {
      if (this.selectTableData.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [];
          this.selectTableData.forEach((item) => {
            ids.push(item.typeId);
          });
          this.$API.wtl_stopCategoryType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 启用
    qiYong(id) {
      this.$confirm("是否启用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.startExceptionType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "启用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 禁用
    jinYong(id) {
      this.$confirm("是否禁用所选数据?", "提示:")
        .then((respon) => {
          let ids = [id];
          this.$API.stopExceptionType({ typeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "禁用成功");
            this.departmentHierarchy();
            this.getData();
          });
        })
        .catch((error) => {});
    },
    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.children || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].children || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },

    // 左边列表
    departmentHierarchy() {
      this.$API.getLeftExceptionTypeList().then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          this.menuTableData = bmList;
          // this.menuTableData = this.diGuiGetMeun(bmList, "-1");
        }
      });
    },
    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.departmentName = item.departmentName;
          obj.children = [];
          temp = this.diGuiGetMeun(data, item.departmentId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      return tree;
    },
    // 弹窗上级地区远程搜索
    remoteMethod2(name, pname) {
      return this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: "parentName",
              conditonVal: pname || "",
            },
            {
              conditonKey: "typeName",
              conditonVal: name || "",
            },
          ],
          number: "exception_type_choose_list",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let datas = res.data.result.datas.data || [];
          datas.unshift({
            typeName: "无上级",
            exceptionTypeId: "-1",
          });
          this.parentList = datas;
          console.log(this.parentList);
        });
    },

    //菜单新建
    menuadd(row) {
      if (row) {
        this.dialogFormData = {
          isShow: "1",
          parentId: String(row.parentId),
          remark: "",
          sort: "1",
          typeName: "",
        };
        this.remoteMethod2(row.typeName);
      } else {
        this.remoteMethod2("");
      }
      this.$nextTick(() => {
        this.PopUpTitle = "新建异常类型";
        this.dialogType = "add";
        this.menushowBOX = true;
      });
    },
    //菜单修改
    async menumodify(row) {
      this.PopUpTitle = "修改异常类型";
      this.dialogType = "edit";
      this.menushowBOX = true;
      await this.remoteMethod2(row.parentName);
      this.dialogFormData.remark = row.remark || "";
      this.dialogFormData.parentId = row.parentId || "";
      this.dialogFormData.typeId = row.typeId || "";
      this.dialogFormData.typeName = row.typeName || "";
      this.dialogFormData.sort = row.sort || "1";
      this.dialogFormData.isShow = String(row.isShow) || "0";
    },
    // 删除
    delBtns(id) {
      this.$confirm("是否删除该类型?", "提示:")
        .then(() => {
          let ids = [id];
          let param = {
            typeIds: ids,
          };
          this.$API.delExceptionType(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.departmentHierarchy();
              this.getData();
            }
          });
        })
        .catch(() => {});
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.dialogFormData = {
        isShow: "1",
        parentId: "",
        remark: "",
        sort: "1",
        typeName: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            // 新建
            let param = {
              isShow: this.dialogFormData.isShow || "0",
              parentId: this.dialogFormData.parentId,
              remark: this.dialogFormData.remark,
              sort: this.dialogFormData.sort || 1,
              typeName: this.dialogFormData.typeName,
            };
            this.$API.addExceptionType(param).then((res) => {
              this.menushowBOX = false;
              this.$message.success(res.data.message || "新建成功");
              this.getData();
              this.departmentHierarchy();
            });
          } else {
            let param = {
              isShow: this.dialogFormData.isShow || "0",
              parentId: this.dialogFormData.parentId,
              remark: this.dialogFormData.remark,
              sort: this.dialogFormData.sort || 1,
              typeName: this.dialogFormData.typeName,
              typeId: this.dialogFormData.typeId,
            };
            this.$API.udpateExceptionType(param).then((res) => {
              this.menushowBOX = false;
              this.$message.success(res.data.message || "修改成功");
              this.getData();
              this.departmentHierarchy();
            });
          }
        }
      });
    },
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;

        this.leftHeight = windonHeight - 85;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    rowClickLeft(tree) {
      console.log(tree, "tree");
      // this.queryData.categoryName = tree.categoryName;
      this.queryData.typeName = tree.typeName;
      this.getData();
    },
    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              that.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            that.myTableHeard = that.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < that.myTableHeard.length; i++) {
            if (that.myTableHeard[i].isTotal) {
              totalArr.push(that.myTableHeard[i].field);
            }
          }
          that.totalArr = totalArr;
        });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },

    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk() {
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //综合查询接口路径
        },
        {
          key: "groupName",
          val: this.pageGroupName,
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = this.$TOOLS.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
  },
};
</script>

<style scoped lang='less'>
.box {
  width: 100%;
  display: flex;
}
.boxleft {
  // width: 40%;
  width: 370px;
  //   min-width: 390px;
  //   height: 88vh;
  overflow: auto;
  margin-right: 30px;
  // border: 1px solid #d7d7d7;
}
.boxright {
  // width: 70%;
  // flex: 1;
  // height: 500px;
  width: calc(100% - 430px);
}
.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}
</style>